"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketplaceIdToCxTupleResult = void 0;
const query_output_1 = require("./query-output");
const data_type_1 = require("../../data/data-type");
/**
 * Data available as part of a MarketplaceID to CXID query result.
 */
class MarketplaceIdToCxTupleResult extends query_output_1.QueryOutput {
}
exports.MarketplaceIdToCxTupleResult = MarketplaceIdToCxTupleResult;
/**
 * cx-id is stored in String format.
 */
MarketplaceIdToCxTupleResult.CX_ID = new MarketplaceIdToCxTupleResult('cx_id', data_type_1.DataType.STRING);
/**
 * cx-family is stored in String format.
 */
MarketplaceIdToCxTupleResult.CX_FAMILY = new MarketplaceIdToCxTupleResult('cx_family', data_type_1.DataType.STRING);
//# sourceMappingURL=marketplaceId-to-cx-tuple-result.js.map